import React from 'react'
import { Navigate } from 'react-router-dom'
import DashboardLayout from './layouts/DashboardLayout'
import MainLayout from './layouts/MainLayout'
import UserListView from './views/user/UserListView'
import PageListView from './views/page/PageListView'
import DashboardView from './views/dashboard/DashboardView'
import LoginView from './views/auth/LoginView'
import NotFoundView from './views/errors/NotFoundView'
import PostListView from './views/post/PostListView'
import PublisherListView from './views/publisher/PublisherListView'
import EventListView from './views/event/EventListView'
import ReportListView from './views/report/ReportListView'
import SettingsView from './views/settings/SettingsView'
import ForgotPasswordView from './views/auth/ForgotPasswordView'

const routes = (isLoggedIn) => [
    {
        path: '/',
        element: !isLoggedIn ? (
            <MainLayout />
        ) : (
            <Navigate to="/app/dashboard" />
        ),
        children: [
            { path: 'login', element: <LoginView /> },
            { path: 'forgot-password', element: <ForgotPasswordView /> },
            { path: '404', element: <NotFoundView /> },
            { path: '/', element: <LoginView /> },
            { path: '*', element: <Navigate to="/404" /> }
        ]
    },
    {
        path: 'app',
        element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
        children: [
            { path: 'dashboard', element: <DashboardView /> },
            { path: 'publisher', element: <PublisherListView /> },
            { path: 'users', element: <UserListView /> },
            { path: 'posts', element: <PostListView /> },
            { path: 'events', element: <EventListView /> },
            { path: 'reports', element: <ReportListView /> },
            { path: 'pages', element: <PageListView /> },
            { path: 'settings', element: <SettingsView /> },
            { path: '/', element: <DashboardView /> },
            { path: '*', element: <Navigate to="/404" /> }
        ]
    }
]

export default routes
